import { render, staticRenderFns } from "./IndexCategory.vue?vue&type=template&id=fea086bc&"
import script from "./IndexCategory.vue?vue&type=script&lang=js&"
export * from "./IndexCategory.vue?vue&type=script&lang=js&"
import style0 from "./IndexCategory.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./IndexCategory.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports